import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
  Grid,
  MenuItem,
} from "@mui/material";
import { NotificationManager } from "react-notifications";
import { SaveVendor, UpdateVendor } from "../../../services/GeneralMaintenanceService";
import { vendorTypeList } from "../../common/statusLists";
import CommonLoader from "../../common/CommonLoader";

const AddEditVendorDialog = ({ open, onClose, onSave, selectedVendor }) => {
  const [vendorId, setVendorId] = useState("");
  const [vendorName, setVendorName] = useState("");
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [phone, setPhone] = useState("");
  const [faxNumber, setFaxNumber] = useState("");
  const [contact, setContact] = useState("");
  const [federalId, setFederalId] = useState("");
  const [vendorType, setVendorType] = useState("");
  const [email, setEmail] = useState("");
  const [country, setCountry] = useState("");
  const [comments, setComments] = useState("");
  const [priceLimit, setPriceLimit] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (selectedVendor) {
      setVendorId(selectedVendor.vendorId || "");
      setVendorName(selectedVendor.vendorName || "");
      setAddress1(selectedVendor.address1 || "");
      setAddress2(selectedVendor.address2 || "");
      setCity(selectedVendor.city || "");
      setState(selectedVendor.state || "");
      setZipCode(selectedVendor.zipCode || "");
      setPhone(selectedVendor.phone || "");
      setFaxNumber(selectedVendor.faxNumber || "");
      setContact(selectedVendor.contact || "");
      setFederalId(selectedVendor.federalId || "");
      setVendorType(selectedVendor.vendorType || "");
      setEmail(selectedVendor.email || "");
      setCountry(selectedVendor.country || "");
      setComments(selectedVendor.comments || "");
      setPriceLimit(selectedVendor.priceLimit || "");
    } else {
      resetForm();
    }
  }, [selectedVendor]);

  const resetForm = () => {
    setVendorId("");
    setVendorName("");
    setAddress1("");
    setAddress2("");
    setCity("");
    setState("");
    setZipCode("");
    setPhone("");
    setFaxNumber("");
    setContact("");
    setFederalId("");
    setVendorType("");
    setEmail("");
    setCountry("");
    setComments("");
    setPriceLimit("");
  };

  const parseData = () => {
    return {
      vendorId,
      vendorName,
      address1,
      address2,
      city,
      state,
      zipCode,
      phone,
      faxNumber,
      contact,
      federalId,
      vendorType,
      email,
      country,
      comments,
      priceLimit: priceLimit !== "" ? parseFloat(priceLimit) : null,
    };
  };
  

  const handleSave = async () => {
    try {
      const vendorData = parseData();

      let response;
      setLoading(true);
      if (selectedVendor) {
        response = await UpdateVendor(vendorData);
        NotificationManager.success("Vendor updated successfully");
      } else {
        response = await SaveVendor(vendorData);
        NotificationManager.success("Vendor saved successfully");
      }      
      if (response.status === 200) {
        setLoading(false);
        onSave();
        onClose();
      } else {
        NotificationManager.error("Error saving/updating vendor");
      }
    } catch (error) {
        setLoading(false);
      NotificationManager.error("Error saving/updating vendor");
    }
  };

  const handleCancel = () => {
    onClose();
  };

  return (
   <>
    <Dialog open={open} onClose={onClose} maxWidth="md">
      <DialogTitle>{selectedVendor ? "Edit Vendor" : "Add New Vendor"}</DialogTitle>
      <DialogContent>
        <Grid container spacing={1.5}>
          <Grid item xs={12} sm={3}>
            <TextField
              label="Vendor Name"
              value={vendorName}
              onChange={(e) => setVendorName(e.target.value)}
              fullWidth
              margin="dense"
              size="small"
              variant="outlined"
              required
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              label="Address 1"
              value={address1}
              onChange={(e) => setAddress1(e.target.value)}
              fullWidth
              margin="dense"
              size="small"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              label="Address 2"
              value={address2}
              onChange={(e) => setAddress2(e.target.value)}
              fullWidth
              margin="dense"
              size="small"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              label="City"
              value={city}
              onChange={(e) => setCity(e.target.value)}
              fullWidth
              margin="dense"
              size="small"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              label="State"
              value={state}
              onChange={(e) => setState(e.target.value)}
              fullWidth
              margin="dense"
              size="small"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              label="Zip Code"
              value={zipCode}
              onChange={(e) => setZipCode(e.target.value)}
              fullWidth
              margin="dense"
              size="small"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              label="Phone"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              fullWidth
              margin="dense"
              size="small"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              label="Fax Number"
              value={faxNumber}
              onChange={(e) => setFaxNumber(e.target.value)}
              fullWidth
              margin="dense"
              size="small"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              label="Contact"
              value={contact}
              onChange={(e) => setContact(e.target.value)}
              fullWidth
              margin="dense"
              size="small"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              label="Federal ID"
              value={federalId}
              onChange={(e) => setFederalId(e.target.value)}
              fullWidth
              margin="dense"
              size="small"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              select
              label="Vendor Type"
              value={vendorType}
              onChange={(e) => setVendorType(e.target.value)}
              fullWidth
              margin="dense"
              size="small"
              variant="outlined"
            >
              {vendorTypeList.map((type) => (
                <MenuItem key={type} value={type}>
                  {type}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              label="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              fullWidth
              margin="dense"
              size="small"
              variant="outlined"
              type="email"
              inputProps={{ maxLength: 100 }}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              label="Country"
              value={country}
              onChange={(e) => setCountry(e.target.value)}
              fullWidth
              margin="dense"
              size="small"
              variant="outlined"
            />
          </Grid>         
          <Grid item xs={12} sm={3}>
            <TextField
              label="Price Limit"
              value={priceLimit}
              onChange={(e) => setPriceLimit(e.target.value)}
              fullWidth
              margin="dense"
              size="small"
              variant="outlined"
              type="number"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Comments"
              value={comments}
              onChange={(e) => setComments(e.target.value)}
              fullWidth
              margin="dense"
              size="small"
              variant="outlined"
              
              rows={3}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} variant="outlined">
          Cancel
        </Button>
        <Button onClick={handleSave} variant="contained" color="primary">
          {selectedVendor ? "Update" : "Save"}
        </Button>
      </DialogActions>
    </Dialog>

    <CommonLoader loading={loading} />
   </>
  );
  
};

export default AddEditVendorDialog;
